import { createMuiTheme } from "@material-ui/core/styles";

export const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#1B9BF9",
      main: "#1B9BF9",
      dark: "#1B9BF9",
      contrastText: "#FFF"
    },
    secondary: {
      light: "#fe791f",
      main: "#fe8637",
      dark: "#FE6806",
      contrastText: "#FFF"
    }
  }
});
